// NOTE: asset details panel reducer, to be iterated
import { Action, Dispatch } from 'redux';

import { IAppState } from './reducers';

const RAW_ASSET_DETAILS = 'catapult:rawAssetDetails';

enum ActionType {
  UpdateAssetDetailsAction = 'RawAssetDetails.UpdateAssetDetailsAction',
  ResetRawAssetDetails = 'RawAssetDetails.ResetRawAssetDetails',
}

interface IAssetDetailsAction extends Action<ActionType> {
  payload: any;
}

const INITIAL_STATE = {} as any;

type IAssetDetails = typeof INITIAL_STATE;

export default (state: IAssetDetails = INITIAL_STATE, action: IAssetDetailsAction) => {
  switch (action.type) {
    case ActionType.UpdateAssetDetailsAction:
      return { ...action.payload };
    case ActionType.ResetRawAssetDetails:
      return { ...INITIAL_STATE };
    default:
      return state;
  }
};

export const setRawAssetDetails = () => (
  dispatch: Dispatch<IAssetDetailsAction | any>,
  getState: () => IAppState,
) => {
  const stored = localStorage.getItem(RAW_ASSET_DETAILS);
  const rawAssetDetails = (stored && stored !== 'undefined') ? JSON.parse(stored) : null;
  dispatch({
    payload: {
      ...rawAssetDetails,
    },
    type: ActionType.UpdateAssetDetailsAction,
  });
};

export const updateRawAssetDetails = (rawAssetDetails: IAssetDetails) => async (
  dispatch: Dispatch<IAssetDetailsAction | any>,
  getState: () => IAppState,
) => {
  // Don't save attachments in localStorage
  localStorage.setItem(RAW_ASSET_DETAILS, JSON.stringify({
    ...rawAssetDetails,
    attachments: [],
  }));

  dispatch({
    payload: {
      ...rawAssetDetails,
    },
    type: ActionType.UpdateAssetDetailsAction,
  });
};

export const rawAssetDetailsInitialState = () => async (
  dispatch: Dispatch<IAssetDetailsAction | any>,
  getState: () => IAppState,
) => {
  dispatch({
    type: ActionType.ResetRawAssetDetails,
  });
};
